export const groqModels = {
    id: "groq",
    name: "Groq",
    npm: "@ai-sdk/groq",
    doc: "https://console.groq.com/docs/models",
    env: ["GROQ_API_KEY"],
    models: {
        "llama-3.1-8b-instant": {
            id: "llama-3.1-8b-instant",
            name: "Llama 3.1 8B Instant",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2023-12",
            release_date: "2024-07-23",
            last_updated: "2024-07-23",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.05,
                output: 0.08,
            },
            limit: {
                context: 131072,
                output: 8192,
            },
        },
        "qwen-qwq-32b": {
            id: "qwen-qwq-32b",
            name: "Qwen QwQ 32B",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2024-09",
            release_date: "2024-11-27",
            last_updated: "2024-11-27",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.29,
                output: 0.39,
            },
            limit: {
                context: 131072,
                output: 16384,
            },
        },
        "llama3-70b-8192": {
            id: "llama3-70b-8192",
            name: "Llama 3 70B",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2023-03",
            release_date: "2024-04-18",
            last_updated: "2024-04-18",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.59,
                output: 0.79,
            },
            limit: {
                context: 8192,
                output: 8192,
            },
        },
        "deepseek-r1-distill-llama-70b": {
            id: "deepseek-r1-distill-llama-70b",
            name: "DeepSeek R1 Distill Llama 70B",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2024-07",
            release_date: "2025-01-20",
            last_updated: "2025-01-20",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.75,
                output: 0.99,
            },
            limit: {
                context: 131072,
                output: 8192,
            },
        },
        "llama3-8b-8192": {
            id: "llama3-8b-8192",
            name: "Llama 3 8B",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2023-03",
            release_date: "2024-04-18",
            last_updated: "2024-04-18",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.05,
                output: 0.08,
            },
            limit: {
                context: 8192,
                output: 8192,
            },
        },
        "gemma2-9b-it": {
            id: "gemma2-9b-it",
            name: "Gemma 2 9B",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-06",
            release_date: "2024-06-27",
            last_updated: "2024-06-27",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.2,
                output: 0.2,
            },
            limit: {
                context: 8192,
                output: 8192,
            },
        },
        "llama-3.3-70b-versatile": {
            id: "llama-3.3-70b-versatile",
            name: "Llama 3.3 70B Versatile",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2023-12",
            release_date: "2024-12-06",
            last_updated: "2024-12-06",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.59,
                output: 0.79,
            },
            limit: {
                context: 131072,
                output: 32768,
            },
        },
        "mistral-saba-24b": {
            id: "mistral-saba-24b",
            name: "Mistral Saba 24B",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-08",
            release_date: "2025-02-06",
            last_updated: "2025-02-06",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0.79,
                output: 0.79,
            },
            limit: {
                context: 32768,
                output: 32768,
            },
        },
        "llama-guard-3-8b": {
            id: "llama-guard-3-8b",
            name: "Llama Guard 3 8B",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: false,
            release_date: "2024-07-23",
            last_updated: "2024-07-23",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.2,
                output: 0.2,
            },
            limit: {
                context: 8192,
                output: 8192,
            },
        },
        "openai/gpt-oss-20b": {
            id: "openai/gpt-oss-20b",
            name: "GPT OSS 20B",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            release_date: "2025-08-05",
            last_updated: "2025-08-05",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.1,
                output: 0.5,
            },
            limit: {
                context: 131072,
                output: 32768,
            },
        },
        "openai/gpt-oss-120b": {
            id: "openai/gpt-oss-120b",
            name: "GPT OSS 120B",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            release_date: "2025-08-05",
            last_updated: "2025-08-05",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.15,
                output: 0.75,
            },
            limit: {
                context: 131072,
                output: 32768,
            },
        },
        "meta-llama/llama-guard-4-12b": {
            id: "meta-llama/llama-guard-4-12b",
            name: "Llama Guard 4 12B",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: false,
            release_date: "2025-04-05",
            last_updated: "2025-04-05",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.2,
                output: 0.2,
            },
            limit: {
                context: 131072,
                output: 128,
            },
        },
        "meta-llama/llama-4-maverick-17b-128e-instruct": {
            id: "meta-llama/llama-4-maverick-17b-128e-instruct",
            name: "Llama 4 Maverick 17B",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-08",
            release_date: "2025-04-05",
            last_updated: "2025-04-05",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.2,
                output: 0.6,
            },
            limit: {
                context: 131072,
                output: 8192,
            },
        },
        "meta-llama/llama-4-scout-17b-16e-instruct": {
            id: "meta-llama/llama-4-scout-17b-16e-instruct",
            name: "Llama 4 Scout 17B",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-08",
            release_date: "2025-04-05",
            last_updated: "2025-04-05",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.11,
                output: 0.34,
            },
            limit: {
                context: 131072,
                output: 8192,
            },
        },
        "qwen/qwen3-32b": {
            id: "qwen/qwen3-32b",
            name: "Qwen3 32B",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2024-11-08",
            release_date: "2024-12-23",
            last_updated: "2024-12-23",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.29,
                output: 0.59,
            },
            limit: {
                context: 131072,
                output: 16384,
            },
        },
        "moonshotai/kimi-k2-instruct-0905": {
            id: "moonshotai/kimi-k2-instruct-0905",
            name: "Kimi K2 Instruct 0905",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-10",
            release_date: "2025-09-05",
            last_updated: "2025-09-05",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 1,
                output: 3,
            },
            limit: {
                context: 262144,
                output: 16384,
            },
        },
        "moonshotai/kimi-k2-instruct": {
            id: "moonshotai/kimi-k2-instruct",
            name: "Kimi K2 Instruct",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-10",
            release_date: "2025-07-14",
            last_updated: "2025-07-14",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 1,
                output: 3,
            },
            limit: {
                context: 131072,
                output: 16384,
            },
        },
    },
};
export default groqModels;
//# sourceMappingURL=groq.js.map